 <!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent{{config.siteName}}
========================================================================================== -->


<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
<!--        <span>COPYRIGHT &copy; {{ new Date().getFullYear() }} {{config.siteName}}</span>-->
        <span>COPYRIGHT &copy; {{ new Date().getFullYear() }} Maxain</span>
<!--        <span class="md:flex hidden items-center">-->
<!--            <a-->
<!--              v-for="(item,index) in config.files"-->
<!--              :key="index"-->
<!--              :href="item.url"-->
<!--              download-->
<!--              target="_blank"-->
<!--            >{{item.fileName}}</a>-->
<!--        </span>-->
    </footer>
</template>

<script>
  import { mapGetters } from 'vuex'
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    },
  computed: {
    ...mapGetters(['config']),
  },
}
</script>
